import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=2ca51af6"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports